module.exports = __webpack_public_path__ + "static/media/image0.582ca977.png";